<wr-base-dialog
  status="info"
  header="Benutzer auswählen oder eingeben"
  [submitResponse]="submit.bind(this)"
  [cancelResponse]="close.bind(this)">

  @if (form) {
    <div>
      <nb-radio-group [(ngModel)]="selectedOption">
        <nb-radio value="user">Benutzer suchen</nb-radio>
        <nb-radio value="manual">Manuelle Eingabe</nb-radio>
      </nb-radio-group>

      @if (selectedOption === 'user') {
        <div class="mt-3">
          <wr-user-select
            id="userId"
            [tenantIds$]="buildingTenantId$"
            [formControl]="$any(form).get('user')">
          </wr-user-select>
        </div>
      } @else {
        <div class="mt-3">
          <form [formGroup]="form">
            <div class="flex-column mb-2">
              <label class="label" for="firstName">Vorname</label>
              <input id="firstName" nbInput fullWidth formControlName="firstName"
                     [status]="form.get('firstName')?.invalid && form.get('firstName')?.touched ? 'danger' : 'basic'">
            </div>

            <div class="flex-column mb-2">
              <label class="label" for="lastName">Nachname</label>
              <input id="lastName" nbInput fullWidth formControlName="lastName"
                     [status]="form.get('lastName')?.invalid && form.get('lastName')?.touched ? 'danger' : 'basic'">
            </div>

            <div class="flex-column">
              <label class="label" for="email">Email</label>
              <input id="email" nbInput fullWidth formControlName="email">
            </div>

            <div class="flex-column">
              <label class="label" for="phoneNumber">Telefon</label>
              <input id="phoneNumber" nbInput fullWidth formControlName="phoneNumber">
            </div>

            <div class="flex-column">
              <label class="label" for="mobileNumber">Mobil</label>
              <input id="mobileNumber" nbInput fullWidth formControlName="mobileNumber">
            </div>
          </form>
        </div>
      }
    </div>
  } @else {
    <div class="flex justify-center p-4">
      <nb-spinner status="primary"></nb-spinner>
    </div>
  }

</wr-base-dialog>
